import { UserRoleResponse } from '../../../../web-api-client';
import { InternalUserRole } from '../../models';

export const mapInternalUserRoleFromResponse = (
  response: UserRoleResponse
): InternalUserRole => ({
  roleId: response.roleId!,
  userId: response.userId!,
  email: response.email!,
  roleName: response.roleName!,
  countryId: response.countryId,
  countryName: response.countryName,
  countries: response.countries?.map(country => ({
    countryId: country.countryId!,
    countryName: country.countryName!,
  })),
});
